import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const numberFormat = { type: 'fixedPoint', precision: 2, useGrouping: true };

const EmptyLocationResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "f2c9a7e3-84b1-4d60-9a2f-6e0c1b58d47a";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    return (
        <div style={{ height: '100%' }}>
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RowId"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                columnAutoWidth={true}
            >
                <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                    <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />
                {/* Default-visible columns */}
                <Column dataField="WarehouseIdentityID" caption="Warehouse" />
                <Column dataField="LocationCode" caption="Location" sortOrder="asc" />
                <Column dataField="Description" caption="Description" />
                <Column dataField="ClassCode" caption="Class" />
                <Column dataField="Subclasscode" caption="Sub Class" />
                <Column dataField="Status" caption="Status" />
                <Column dataField="CapacityVolume" caption="Capacity Volume" dataType="number" format={numberFormat} />
                <Column dataField="VolumeInStock" caption="Volume In Stock" dataType="number" format={numberFormat} />
                <Column dataField="Abs" caption="Available Volume" dataType="number" format={numberFormat} />
                <Column dataField="Available" caption="% Available" dataType="number" format={numberFormat} />
                <Column dataField="UsedSpace" caption="Used Space" dataType="number" />
                <Column dataField="OnHandQuantityInStock" caption="On Hand Qty" dataType="number" format={numberFormat} />
                {/* Column chooser (hidden by default) */}
                <Column dataField="WarehouseName" caption="Warehouse Name" visible={false} />
                <Column dataField="Dimensions" caption="Dimensions" visible={false} />
                <Column dataField="ProfileCode" caption="Profile" visible={false} />
                <Column dataField="Priority" caption="Priority" visible={false} />
                <Column dataField="Comment" caption="Comment" visible={false} />
                <Column dataField="LocationType" caption="Location Type" visible={false} />
                <Column dataField="OnHandVolumeInStock" caption="On Hand Volume" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="AvailableVolumeInStock" caption="Available Volume In Stock" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="AvailableQuantityInStock" caption="Available Qty In Stock" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="QuantityInStock" caption="Quantity In Stock" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="QuantityInStockLessShip" caption="Quantity In Stock Less Ship" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="VolumeInStockLessShip" caption="Volume In Stock Less Ship" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="UsedSpaceLessShip" caption="Used Space Less Ship" visible={false} dataType="number" />
                <Column dataField="UnitsPerPackageQty" caption="Units Per Package Qty" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="Height" caption="Height" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="Width" caption="Width" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="Depth" caption="Depth" visible={false} dataType="number" format={numberFormat} />
                <Column dataField="CapacityUnits" caption="Capacity Units" visible={false} dataType="number" />
                <Column dataField="CapacityLimitFlag" caption="Capacity Limit" visible={false} />
                <Column dataField="CapacityPieces" caption="Capacity Pieces" visible={false} dataType="number" />
                <Column dataField="CapacityPiecesLimitFlag" caption="Capacity Pieces Limit" visible={false} />
                <Column dataField="CapacityContainerUnits" caption="Capacity Container Units" visible={false} dataType="number" />
                <Column dataField="CapacityContainerLimitFlag" caption="Capacity Container Limit" visible={false} />
                <Column dataField="CapacityShippingUnits" caption="Capacity Shipping Units" visible={false} dataType="number" />
                <Column dataField="CapacityShippingUnitsLimitFlag" caption="Capacity Shipping Units Limit" visible={false} />
                <Column dataField="CapacityGrossWeight" caption="Capacity Gross Weight" visible={false} dataType="number" />
                <Column dataField="CapacityGrossWeightLimitFlag" caption="Capacity Gross Weight Limit" visible={false} />
                <Column dataField="CapacityNetWeight" caption="Capacity Net Weight" visible={false} dataType="number" />
                <Column dataField="CapacityNetWeightLimitFlag" caption="Capacity Net Weight Limit" visible={false} />
                <Column dataField="CapacityArea" caption="Capacity Area" visible={false} dataType="number" />
                <Column dataField="CapacityAreaLimitFlag" caption="Capacity Area Limit" visible={false} />
                <Column dataField="CapacityVolumeLimitFlag" caption="Capacity Volume Limit" visible={false} />
                <Column dataField="MinimumUnits" caption="Minimum Units" visible={false} dataType="number" />
                <Column dataField="MaximumUnits" caption="Maximum Units" visible={false} dataType="number" />
                <Column dataField="PickSequence" caption="Pick Sequence" visible={false} dataType="number" />
                <Column dataField="RecordType" caption="Record Type" visible={false} />
                <Column dataField="CreationDateTime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="CreationUserID" caption="Created By" visible={false} />
                <Column dataField="LastUpdateDateTime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LastUpdateUserID" caption="Last Updated By" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EmptyLocationResult);
